import React from 'react';
import { Map, PlayCircle, PauseCircle, CheckCircle2, Hammer, Sprout } from 'lucide-react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';

export function ZoneStatsCards({ stats }: { stats: any }) {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng khu vực',
      value: stats?.total || 0,
      suffix: 'Khu vực',
      icon: Map,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'neutral',
      trendValue: 'Tổng quan',
      chartColor: 'bg-blue-500',
      chartData: [20, 22, 24, 25, stats?.total || 26]
    },
    {
      title: 'Đang hoạt động',
      value: stats?.active || 0,
      suffix: 'Khu vực',
      icon: PlayCircle,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: stats?.activePct || '0%',
      chartColor: 'bg-emerald-500',
      chartData: [15, 18, 19, 20, stats?.active || 21]
    },
    {
      title: 'Tạm dừng',
      value: stats?.paused || 0,
      suffix: 'Khu vực',
      icon: PauseCircle,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'down',
      trendValue: stats?.pausedPct || '0%',
      chartColor: 'bg-amber-500',
      chartData: [5, 4, 3, 2, stats?.paused || 1]
    },
    {
      title: 'Đã hoàn thành',
      value: stats?.completed || 0,
      suffix: 'Khu vực',
      icon: CheckCircle2,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: stats?.completedPct || '0%',
      chartColor: 'bg-indigo-500',
      chartData: [0, 1, 2, 3, stats?.completed || 4]
    },
    {
      title: 'Khu vực thi công',
      value: stats?.construction || 0,
      suffix: 'Khu vực',
      icon: Hammer,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'up',
      trendValue: 'Thiết lập',
      chartColor: 'bg-rose-500',
      chartData: [10, 12, 11, 13, stats?.construction || 14]
    },
    {
      title: 'Khu vực bảo dưỡng',
      value: stats?.maintenance || 0,
      suffix: 'Khu vực',
      icon: Sprout,
      color: 'text-teal-600',
      bg: 'bg-teal-50',
      trend: 'up',
      trendValue: 'Duy trì',
      chartColor: 'bg-teal-500',
      chartData: [5, 6, 8, 7, stats?.maintenance || 7]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
